/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Videos_Status_FailedInputs */

const en_settings_videos_status_failed = /** @type {(inputs: Settings_Videos_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed, credits refunded`)
};

/**
* | output |
* | --- |
* | "Failed, credits refunded" |
*
* @param {Settings_Videos_Status_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_videos_status_failed = /** @type {((inputs?: Settings_Videos_Status_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Videos_Status_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_videos_status_failed(inputs)
});
export { settings_videos_status_failed as "settings.videos.status_failed" }